<template>
  <div class="access">
    <div class="access__title">Права доступа</div>
    <Table
      v-if="accessTable" />
    <BaseBtn
      v-if="accessTable && configAccess.access_rights.main === 2"
      class="access__add"
      :text="'Добавить роль'"
      @btnClick="updatePopup(true, 'PopupAccessAdd')" />
    <Roles v-if="rolesEmployees.length && accessTable" />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    BaseBtn: () => import('@/components/base/BaseBtn'),
    Roles: () => import('./components/Roles'),
    Table: () => import('./components/Table'),
  },

  metaInfo() {
    return {
      title: `Права доступа - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
      accessTable: state => state.account.accesses.accessTable,
      rolesEmployees: state => state.account.accesses.rolesEmployees,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('account/accesses', [
      'accessTableLoad',
      'rolesEmployeesLoad',
      'rolesLoad',
    ]),

    async fetchData() {
      await Promise.all([
        this.rolesLoad(),
        this.accessTableLoad(),
        this.rolesEmployeesLoad(),
      ]).then(res => {
        this.togglePreload();
      });
    },
  },

  created() {
    this.togglePreload();
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
  .access {
    padding-bottom: 30px;

    &__title {
      font-weight: bold;
      font-size: 24px;
      line-height: 30px;
      position: fixed;
      z-index: 120;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 53px;
      margin: 0;

      @media(max-width: $desktop) {
        position: static;
        height: auto;
        transform: translateX(0);
        margin-bottom: 11px;
      }
    }

    &__add {
      margin-bottom: 43px;
    }
  }
</style>
